<template>
  <component v-bind:is="currentItemComponent" :index="menu.path" :key="menu.path">
    <i :class="menu.icon" v-if="menu.icon && !hc"></i>
    <!-- <span v-if="!hc" slot="title">{{menu.text}}</span> -->
    <el-badge v-if="!hc"
              :value="menu.badge"
              :is-dot="dotBadge"
              :max="10"
              class="menu-badge"
              :class="{'dot-badge': dotBadge}"
              :hidden="!menu.badge"
              slot="title">{{menu.text}}</el-badge>
    <template slot="title" v-if="hc">
      <i :class="menu.icon" v-if="menu.icon"></i>
      <!-- <span slot="title">{{menu.text}}</span> -->
      <el-badge :value="menu.badge"
                v-if="!isCollapse"
                :is-dot="dotBadge"
                :max="10"
                class="menu-badge"
                :class="{'dot-badge': dotBadge}"
                :hidden="!menu.badge"
                slot="title">{{menu.text}}
      </el-badge>
    </template>
    <tree-menu-item :menu="child"
                    :key="child.name"
                    v-for="child in menu.children"
                    v-if="hc && child.menu">
    </tree-menu-item>
  </component>
</template>

<script>
export default {
  name: 'TreeMenuItem',
  props: {
    menu: Object,
    dotBadge: {
      type: Boolean,
      default: false
    },
    isCollapse: Boolean
  },
  data () {
    return {
      hc: false
    }
  },
  computed: {
    currentItemComponent: function () {
      return this.hasChildren() ? 'el-submenu' : 'el-menu-item'
    }
  },
  methods: {
    hasChildren () {
      this.hc = this.menu.hasChildren !== false && this.menu.children && this.menu.children.length > 0
      return this.hc
    }
  }
}
</script>

<style scoped>
</style>
